export const APP_VERSION_CHECK_INTERVAL_MS = 5 * 60 * 1000;

export const APP_VERSION_UPDATE_MESSAGE =
  'A new version of Disney Campaign Manager is available. Refresh to get the latest updates.';
